import script from "./QrReservaServicios.vue?vue&type=script&setup=true&lang=js"
export * from "./QrReservaServicios.vue?vue&type=script&setup=true&lang=js"

import "./QrReservaServicios.vue?vue&type=style&index=0&id=2bc18178&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc18178"]])

export default __exports__